let moment = require('engine/moment-with-locale');

let getTimeZoneName = require('./getTimeZoneName');
let adjustWeekRange = require('adjustWeekRange');

const LANG = require('config').lang;

class WeekRangeElement extends HTMLElement {

  constructor() {
    super();

    this.render();
  }

  static get observedAttributes() {
    return ['weekdays', 'format', 'with-zone', 'to', 'from'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  format(date, format, withZone) {

    let formatted = moment(date).utcOffset(-new Date().getTimezoneOffset()).format(format);

    if (withZone) {
      formatted += ' ' + getTimeZoneName();
    }

    return formatted;
  }


  // from="..." to="..."
  render() {

    if (this.getAttribute('weekdays')[0] === '{') return; // Angular

    // firefox throws error with infinite recursion otherwise
    let params = ['weekdays', 'with-zone', 'from', 'to'].map(f => this.getAttribute(f)).join(':');

    if (this.lastParams === params) {
      return;
    }
    this.lastParams = params;

    let weekDays = this.getAttribute('weekdays').split(',').map(Number);

    let from = this.getAttribute('from');
    let to = this.getAttribute('to');

    // apply timezone shift
    [weekDays, from, to] = adjustWeekRange(weekDays, from, to,  - new Date().getTimezoneOffset());

    let shortDays;
    if (LANG === 'ru') {
      shortDays = ['', "пн", "вт", "ср", "чт", "пт", "сб", "вс"];
    } else {
      shortDays = ['', "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    }

    weekDays = weekDays.map(day => shortDays[day]);

    if (LANG === 'ru') {
      weekDays = weekDays.join('/');
    } else {
      weekDays = weekDays.join(', ');
    }

    if (this.hasAttribute('with-zone')) {
      let zone = getTimeZoneName();
      this.setAttribute('data-tooltip', "Время указано в вашем часовом поясе,<br>по данным браузера это " + zone);
    }

    this.innerHTML = weekDays + ' ' + from + ' – ' + to;

  }

}

window.WeekRangeElement = WeekRangeElement;

window.customElements.define('week-range', WeekRangeElement);
